import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import Api from "@services/Api";
import { Product, User } from "@utils/types";

const app = createSlice({
  name: "app",
  initialState: {
    user: null as User | null,
    loadingUser: true,
    isSidebarToggled: window.innerWidth > 768,
    isOrderModalOpen: false,
    selectedProduct: null as Product | null,
    companyCode: "",
  },
  reducers: {
    setCompanyCode(state, action: PayloadAction<string>) {
      state.companyCode = action.payload;
    },
    toggleSidebar(state) {
      state.isSidebarToggled = !state.isSidebarToggled;
    },
    setSelectedProduct(state, action: PayloadAction<Product | null>) {
      state.selectedProduct = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserData.pending, (state) => {
      state.loadingUser = true;
    });
    builder.addCase(fetchUserData.fulfilled, (state, action) => {
      state.user = action.payload;
      state.loadingUser = false;
    });
    builder.addCase(fetchUserData.rejected, (state) => {
      state.loadingUser = false;
    });
  },
});

export default app.reducer;

export const { toggleSidebar, setSelectedProduct, setCompanyCode } = app.actions;

export const fetchUserData = createAsyncThunk("app/user_data", async (payload, { rejectWithValue }) => {
  const token = localStorage.getItem("user_token");
  if (!token) return;
  try {
    const { data } = await Api.get(`/user/profile`);
    return data.user;
  } catch (error) {
    console.log(error, "error on fetchOrder()");
    throw rejectWithValue(error);
  }
});
